// extracted by mini-css-extract-plugin
module.exports = {"questionWrapper":"styles_questionWrapper__GQi4f","questionCopy":"styles_questionCopy__RnlVD"};